import type { AnalysesTab } from '@practium/features/analyses';

const ANALYSES_TABS: readonly AnalysesTab[] = ['soil', 'plant'];

export const isAnalysesTab = (value: string | null): value is AnalysesTab =>
	ANALYSES_TABS.includes(value as AnalysesTab);

export const getAnalysesListPath = (tab: AnalysesTab) => `/analises?tab=${tab}`;
